import { format, set } from 'date-fns';

/*********************************************************
 * Newly Added BEGIN 
 *********************************************************/
const getDateISOString=(d)=>
{
    if (d instanceof Date)  {
        if (!isNaN(d))
        {
        return format(d,'yyyy-MM-dd') 
        }
    }

    return null;
}

const getDateDisplayIdString=(d)=>
{ 
    if (d instanceof Date)  {
        if (!isNaN(d))
        {
        return format(d,'dd.MM.yyyy')
        }
    }

    return null;
}
const regxTime = /^[0-2](\d):[0-5][0-9]$/

const getTimeStr=(t)=>{
  
    if (!t||!t.match(regxTime) ) return null
    
    if (typeof t==='string')
    {
        let ss = t.split(':')
        if (ss.length!==2 ||  isNaN(ss[0]) || isNaN(ss[1]) ) return null
        let h=parseInt(ss[0]);
        let m=parseInt(ss[1]);

        if (h<0 || h>23 || m<0 || m>59) return null;

        return h.toString().padStart(2,0)+":"+m.toString().padStart(2,0)
    }
    return null;
}

const getDateTime=(d, t)=>{
    let d1= getDateISOString(d);
    let t1= getTimeStr(t);

    return (d1 && t1) ? d1+' '+t1 :''
}
/*********************************************************
 * Newly Added END 
 *********************************************************/


const getWeekDayName=(d, longNme)=>
{
    if (longNme) d.toLocaleString('en-us', {  weekday: 'long' })
    return   d.toLocaleString('en-us', {  weekday: 'short' })
}




const gennerateTimes=()=>{
    let arr=[];
    for (let i=0; i<24; i++)
    {
        let s = (i<10 ? '0':'')+i.toString()+':';

        arr.push(s+'00')
        arr.push(s+'30')
    }
    arr.push('23:59')
    return arr
}

const allStartTimes = gennerateTimes()
const allEndTimes = gennerateTimes()

const getAllDays=()=>{
    let x = [...Array(31).keys()];
    x.shift();
    
    return x;
}

const getWeekDays=()=>{
    let x = [...Array(7).keys()];
    
    return x;
}

// allStartTimes.pop()
// allEndTimes.shift()

const getValidEndTimes=(tm)=>{

    let tm1=tm
    if (!tm)
    {
        let d=new Date();
        let h = d.getHours();
        let m=d.getMinutes();
        tm1 = (h<10?'0':'')+h.toString();

        tm1 = ':' +(m<10?'0':'')+m.toString();
        
    }
    return allEndTimes.filter(x=>x>tm1)
}


export {getValidEndTimes, allStartTimes, allEndTimes, getAllDays, getWeekDays, getWeekDayName, getDateISOString, 
    getTimeStr, getDateTime,getDateDisplayIdString}